import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import "./Assistant.css";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../Loader";
import { createOneContact } from "../../services/ContactList";
import {
  createOneVoiceAssistant,
  getVoiceAssitant,
} from "../../services/Assistant";
import { useAuth } from "../../context/AuthContext";
import AddIcon from "@mui/icons-material/Add";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ECE0FF',
    color: '#747474',
    // maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    // border: '1px solid #dadde9',
    borderRadius: '15px',
    boxShadow: '0px 0px 11px 0px rgba(128, 139, 157, 0.15)',
  },
}));

const drawerWidth = 300;

const Assistant = () => {
  const notify = () => toast.success("Setup Completed");
  const remove = () => toast.success("Deleted successfully");

  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => setPop(true);
  const handlePopClose = () => setPop(false);

  const [voices, setVoices] = useState([]);

  const navigate = useNavigate();

  const { userResponse } = useAuth();

  const [createVoiceAssistant, setCreateVoiceAssistant] = useState({
    name: "",
    companyName: "",
    // goal: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    companyName: "",
    // goal: "",
  });
  const [load, setLoad] = useState(false);
  const [allvoiceAssitant, setAllVoiceAssistant] = useState([]);

  const [assistangResult, setAssistantResult] = useState({});
  const [isLoading,setIsLoading]=useState(true);

  useEffect(() => {
    // if(userResponse?.haveAssitant===true){
    getAllVoiceAssistant();
    // }
  }, []);

  const getAllVoiceAssistant = async () => {
    setIsLoading(true);
    const response = await getVoiceAssitant();
    if (response?.data?.success === true) {
      setAllVoiceAssistant(response.data.result);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setCreateVoiceAssistant({ ...createVoiceAssistant, [name]: value });
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";
    const regex = /^[a-zA-Z\s]*$/;

    if (value === "" || value === undefined) {
      if (fieldName === "name") {
        if (!regex.test(value)) {
          // setError('Name cannot contain special characters');
          errorMessage = `Name cannot contain special characters`;
          isValid = false;
        }
        // errorMessage = `Assistant Name is required`;
        // isValid = false;
      }
      if (fieldName === "companyName") {
        // errorMessage = `Company Name is required`;
        // isValid = false;
      }
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate password
    if (!createVoiceAssistant.name) {
      formErrors.name = "Assistant Name is required";
      isValid = false;
    }

    // if (!createVoiceAssistant.goal) {
    //   formErrors.goal = "goal is required";
    //   isValid = false;
    // }

    if (!createVoiceAssistant.companyName) {
      formErrors.companyName = "Company Name is required";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    if (validate()) {
      setLoad(true);
      const response = await createOneVoiceAssistant(createVoiceAssistant);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        handlePopClose();
        setAssistantResult(response.data.result);

        // setCreateVoiceAssistant({});
        // getAllVoiceAssistant();
        setTimeout(() => {
          navigate("/createassistant", {
            state: {
              result: response?.data?.result,
              id: response.data.result.Id,
            },
          });
        }, 500);
        setLoad(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };
  if(isLoading) return <Loader/>
  return (
    <div className="dashboard assitant-full">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}> */}
        {/* <SideBar /> */}
        {/* {userResponse.haveAssitant === true && <Loader />} */}
        {/* {isLoading===true &&  <Loader /> } */}
       
        {/* <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: isLgUp ? 5 : 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            height: "100vh",
            marginTop: isLgUp ? "0px" : "80px",
          }}
          className="content-wrapper"
        > */}
          {/* <Loader /> */}

          <Grid2 container spacing={2}>
            <Grid2
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              className="mb-20"
            >
              <div className="create-assitant">
                {/* className="create-assitant" */}

                {allvoiceAssitant.length === 0 ? (
                  <div>
                    <h1>Create Your First AI Voice Assistant</h1>
                    <p>
                      Rorem ipsum dolor sit amet, consectetur adipiscing
                      elit.Rorem ipsum dolor sit amet, consectetur adipiscing
                      elit.
                    </p>
                    <div className="graient-btn mt-30">
                      <Button className="display-1" onClick={handlePopOpen}>
                        Create an AI Voice Assistant <AutoAwesomeIcon />
                      </Button>
                    </div>
                    <div className="modal-popup text-center">
                      <Modal
                        open={pop}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box className="common-modal-box">
                        <div className="close-icons-popup">
                        <HighlightOffIcon onClick={handlePopClose} />
                      </div>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                            Create Voice Assistant
                          </Typography>
                          <div className="assistant-cnt">
                            <div className="input-common mt-20">
                            <div className="display-1">
                            <label>Assistant’s Name *</label>
                            <HtmlTooltip placement="right"
                              title={
                                <React.Fragment>
                                  <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>What name would you like to give your assistant?</Typography>
                                </React.Fragment>
                              }>
                              <InfoRoundedIcon />
                            </HtmlTooltip></div>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                name="name"
                                value={createVoiceAssistant.name}
                                required
                                onChange={(e) => handleChange(e)}
                                onFocus={(e) => validateFocus(e)}
                                onInput={validateFocus}
                                error={!!errors.name}
                                helperText={errors.name}
                              />
                            </div>
                            {/* <div className="input-common mt-20">
        <label>Goal *</label>
        <TextField
          fullWidth
          id="fullWidth"
          name="goal"
          value={createVoiceAssistant.goal}
          required
          onChange={(e) => handleChange(e)}
          onFocus={(e) => validateFocus(e)}
          onInput={validateFocus}
          error={!!errors.goal}
          helperText={errors.goal}
        />
      </div> */}
                            <div className="input-common mt-20">
                            <div className="display-1">
                            <label>Enter The company Name *</label>
                            <HtmlTooltip placement="right"
                              title={
                                <React.Fragment>
                                  <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>Please enter the name of your company or organization.</Typography>
                                </React.Fragment>
                              }>
                              <InfoRoundedIcon />
                            </HtmlTooltip></div>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                rows={4}
                                name="companyName"
                                value={createVoiceAssistant.companyName}
                                required
                                onChange={(e) => handleChange(e)}
                                onFocus={(e) => validateFocus(e)}
                                onInput={validateFocus}
                                error={!!errors.companyName}
                                helperText={errors.companyName}
                              />
                            </div>
                          </div>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20 assitant-stack"
                          >
                            <div className="border-graient mt-10">
                              <Button
                                onClick={() => {
                                  handlePopClose();
                                  setErrors({});
                                  setCreateVoiceAssistant({});
                                }}
                              >
                                Cancel
                              </Button>
                            </div>
                            <div className="border-graient gradient-bg mt-10">
                              {load ? (
                                <Button>Processing...</Button>
                              ) : (
                                <Button
                                  // onClick={() => {
                                  //   navigate("/contact-list-table");
                                  // }}
                                  onClick={handleSubmit}
                                >
                                  Save
                                </Button>
                              )}
                            </div>
                          </Stack>
                        </Box>
                      </Modal>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="graient-btn mt-30 text-left">
                      <h3>Assistant</h3>
                      <Button className="display-1" onClick={handlePopOpen}>
                        Create an AI Voice Assistant <AddIcon />
                      </Button>
                    </div>
                    <div className="modal-popup text-center">
                      <Modal
                        open={pop}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <Box className="common-modal-box">
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                          >
                             <div className="close-icons-popup">
                        <HighlightOffIcon onClick={handlePopClose} />
                      </div>
                            Create Voice Assistant
                          </Typography>
                          <div className="assistant-cnt">
                            <div className="input-common mt-20">
                            <div className="display-1">
                            <label>Assistant’s Name *</label>
                            <HtmlTooltip placement="right"
                              title={
                                <React.Fragment>
                                  <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>What name would you like to give your assistant?</Typography>
                                </React.Fragment>
                              }>
                              <InfoRoundedIcon />
                            </HtmlTooltip></div>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                name="name"
                                value={createVoiceAssistant.name}
                                required
                                onChange={(e) => handleChange(e)}
                                onFocus={(e) => validateFocus(e)}
                                onInput={validateFocus}
                                error={!!errors.name}
                                helperText={errors.name}
                              />
                            </div>
                            {/* <div className="input-common mt-20">
        <label>Goal *</label>
        <TextField
          fullWidth
          id="fullWidth"
          name="goal"
          value={createVoiceAssistant.goal}
          required
          onChange={(e) => handleChange(e)}
          onFocus={(e) => validateFocus(e)}
          onInput={validateFocus}
          error={!!errors.goal}
          helperText={errors.goal}
        />
      </div> */}
                            <div className="input-common mt-20">
                            <div className="display-1">
                            <label>Enter The company Name *</label>
                            <HtmlTooltip placement="right"
                              title={
                                <React.Fragment>
                                  <Typography color="inherit" sx={{ fontSize: '12px', padding: '7px' }}>Please enter the name of your company or organization.</Typography>
                                </React.Fragment>
                              }>
                              <InfoRoundedIcon />
                            </HtmlTooltip></div>
                              <TextField
                                fullWidth
                                id="fullWidth"
                                rows={4}
                                name="companyName"
                                value={createVoiceAssistant.companyName}
                                required
                                onChange={(e) => handleChange(e)}
                                onFocus={(e) => validateFocus(e)}
                                onInput={validateFocus}
                                error={!!errors.companyName}
                                helperText={errors.companyName}
                              />
                            </div>
                          </div>
                          <Stack
                            direction="row"
                            spacing={2}
                            sx={{ justifyContent: "center" }}
                            className="mt-20 assitant-stack"
                          >
                            <div className="border-graient mt-10">
                              <Button
                                onClick={() => {
                                  handlePopClose();
                                  setErrors({});
                                  setCreateVoiceAssistant({});
                                }}
                              >
                                Cancel
                              </Button>
                            </div>
                            <div className="border-graient gradient-bg mt-10">
                              {load ? (
                                <Button>Processing...</Button>
                              ) : (
                                <Button
                                  // onClick={() => {
                                  //   navigate("/contact-list-table");
                                  // }}
                                  onClick={handleSubmit}
                                >
                                  Save
                                </Button>
                              )}
                            </div>
                          </Stack>
                        </Box>
                      </Modal>
                    </div>
                    <div className="add-assitant-card-sctn mt-20">
                      <Grid2 container spacing={2}>
                        {allvoiceAssitant?.length > 0 &&
                          allvoiceAssitant?.map((item, index) => {
                            return (
                              <Grid2
                                item
                                size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                                className="create-card mb-20"
                              >
                                <div className="create-card-color display-2">
                                  <h4>{item?.name}</h4>
                                  <DeleteIcon
                                    onClick={remove}
                                    className="cursor"
                                  />
                                </div>
                                <div className="create-card-text">
                                  {/* <p>{item?.goal}</p> */}
                                  <Link>
                                    <span>{item?.companyName}</span>
                                  </Link>
                                  <Stack direction="row" spacing={2}>
                                    <div className="theme-borde-clr mt-10">
                                      <Button
                                        onClick={() => {
                                          navigate("/createassistant", {
                                            state: {
                                              id: item?.id,
                                              result: item,
                                            },
                                          });
                                        }}
                                      >
                                        SET UP
                                      </Button>
                                    </div>

                                    {/* <div className="theme-borde-clr mt-10">
                                      <Button>Cancel</Button>
                                    </div> */}
                                  </Stack>
                                </div>
                              </Grid2>
                            );
                          })}

                        {/* <Grid2
                        item
                        size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                        className="create-card mb-20"
                      >
                        <div className="create-card-color display-2">
                          <h4>Ahgg</h4>
                          <DeleteIcon onClick={remove} className="cursor" />
                        </div>
                        <div className="create-card-text">
                          <p>Goal</p>
                          <Link to="/createassistant">
                            <span>Add assistant</span>
                          </Link>
                          <Stack direction="row" spacing={2}>
                            <div className="theme-borde-clr mt-10">
                              <Button
                                onClick={() => {
                                  navigate("/createassistant");
                                }}
                              >
                                SET UP
                              </Button>
                            </div>
                            <ToastContainer
                              position="top-right"
                              autoClose={5000}
                              hideProgressBar={false}
                              newestOnTop={false}
                              closeOnClick={false}
                              rtl={false}
                              pauseOnFocusLoss
                              draggable
                              pauseOnHover
                              theme="colored"
                            />
                            <div className="theme-borde-clr mt-10">
                              <Button>Cancel</Button>
                            </div>
                          </Stack>
                        </div>
                      </Grid2> */}
                      </Grid2>
                    </div>
                  </div>
                )}
              </div>
            </Grid2>
          </Grid2>
        {/* </Box>
      </Box> */}
    </div>
  );
};

export default Assistant;
